const ErrorFilled = () => (
  <>
    <path
      fill="currentColor"
      d="M12 16.462q.261 0 .438-.177a.6.6 0 0 0 .178-.439.6.6 0 0 0-.178-.438.6.6 0 0 0-.438-.177.6.6 0 0 0-.438.177.6.6 0 0 0-.178.438q0 .261.178.439a.6.6 0 0 0 .438.177m0-3.308q.214 0 .357-.144a.49.49 0 0 0 .143-.356v-5a.48.48 0 0 0-.144-.356.49.49 0 0 0-.357-.144.48.48 0 0 0-.356.144.49.49 0 0 0-.143.356v5q0 .212.144.356a.49.49 0 0 0 .357.144M12.004 21a8.8 8.8 0 0 1-3.51-.709 9.1 9.1 0 0 1-2.859-1.922 9.1 9.1 0 0 1-1.925-2.857A8.75 8.75 0 0 1 3 12.003q0-1.866.708-3.51a9.1 9.1 0 0 1 1.923-2.859 9.1 9.1 0 0 1 2.857-1.925A8.75 8.75 0 0 1 11.997 3q1.866 0 3.51.708a9.1 9.1 0 0 1 2.859 1.923 9.1 9.1 0 0 1 1.925 2.857A8.75 8.75 0 0 1 21 11.997a8.8 8.8 0 0 1-.709 3.51 9.1 9.1 0 0 1-1.922 2.859 9.1 9.1 0 0 1-2.857 1.925 8.75 8.75 0 0 1-3.509.709"
    />
  </>
)
export default ErrorFilled
